module.exports = __webpack_public_path__ + "static/media/biotrue_bundle_calendar.a2443edd.jpg";